import axios from 'axios';

import { LOCAL_STORAGE_STORE_CONSTANTS } from 'constants/general';

const API_ROOT = process.env.REACT_APP_API_URL;

export const api = axios.create({
    baseURL: API_ROOT,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((base) => {
    const config = { ...base };
    const user = localStorage.getItem(LOCAL_STORAGE_STORE_CONSTANTS.X_USER);
    if (user) {
        const localUserSession = JSON.parse(user);
        const { token } = localUserSession;

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            delete config.headers.Authorization;
        }
    }
    return config;
});
